import React, { useContext, useEffect, useState } from 'react'
import UserContext from './UserContext'
import { toast } from 'react-toastify';
import StateContext from '../state/StateContext';
import axios from 'axios';


const User = (props) => {

    const { setEmployees, setLoading, FCM_token, setNotifications, setFCM_token, setGroupDetails, setAllTickets, tickets , setTickets, currentPage, 
        setCurrentPage, totalPages, setTotalPages, totalTickets, setTotalTickets, 
        isLoading, setIsLoading, hasMore, setHasMore, fetching, setFetching, load, setLoad,
        filterItem, setFilterItem, filters, setFilters,
        fromDate, setFromDate, toDate, setToDate, sortBy, setSortBy,sortOrder, setSortOrder,
        searchValue, setSearchValue, chatMessages, setChatMessages, by_search, setBy_search, me_search, 
        requests, setRequests, requestCurrentPage, setRequestCurrentPage, requestHasMore, setRequestHasMore,
        requestTotal, setRequestTotal, requestTotalPages, setRequestTotalPages, setAgencies, setAgencyUsers,
        agency, setAgency, tags, setTags
    } = useContext(StateContext)
    const [user, setUser] = useState('');
    const token = localStorage.getItem("token")
    const [user_verified, setUser_verified] = useState(false);
    const [detailModal, setDetailModal] = useState(false);

    const getUser = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + "api/auth/getUser", {
                headers: {
                    'Content-Type': "application/json",
                    'auth-token': `${token}`
                }
            });

            const json = response.data;
            if (json.success) {
                setUser(json.user);
            } else {
                console.log(json.message);
                toast.error(json.error || json.message || "Some Error occurred");
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getEmployees = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + "api/auth/getAllEmployees", {
                headers: {
                    "Content-Type": "application/json",
                    'auth-token': `${token}`
                }
            });
            const json = response.data;
            if (json.success) {
                setEmployees(json.users);
            } else {
                console.log(json.error || json.message);
                toast.error(json.error || json.message || "Some Error occurred");
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getAgencyUsers = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + "api/auth/getAllUsers", {
                headers: {
                    "Content-Type": "application/json",
                    'auth-token': `${token}`
                }
            });
            const json = response.data;
            if (json.success) {
                setAgencyUsers(json.users.filter(user => user.role === "agency"));
            } else {
                console.log(json.error || json.message);
                toast.error(json.error || json.message || "Some Error occurred");
            }
        } catch (error) {
            console.log(error);
        }
    };

    const StoreToken = async () => {
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + "api/auth/updateFCMtoken",
                { fcm_token: FCM_token },
                {
                    headers: {
                        "Content-Type": "application/json",
                        'auth-token': `${token}`
                    }
                }
            );

            const json = response.data;
            if (json.success) {
                console.log(json);
            } else {
                console.log(json.error);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getTickets = async (page, filter = filters, deadLineFrom = fromDate, deadLineTo = toDate, search = searchValue, sort = sortBy, order = sortOrder, byMe = by_search, toMe = me_search, active ) => {
        try {
            if(fetching && tickets.length > 1) return;
            setLoad(true)
            const response = await axios.get(`${process.env.REACT_APP_API_URL}api/ticket/getAllTickets/${page}`, {
                params: {
                    filters: filter,         // e.g., ['completed', 'high priority']
                    fromDate: deadLineFrom,       // e.g., '2025-01-01'
                    toDate: deadLineTo,           // e.g., '2025-01-31'
                    sortBy: sort,           // e.g., 'priority'
                    sortOrder: order,     // e.g., 'asc' or 'desc'
                    search: search,           // e.g., 'urgent'
                    limit: 15,
                    toMe: toMe,
                    byMe: byMe,
                    active: active               
                },
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${token}`,
                },
            });
    
            const json = response.data;
    
            if (json.success) {
                console.log("Response JSON:", json);
    
                if (json.tickets) {
                    // Sort tickets by updated_at in ascending order
                    const sorted = json.tickets
    
                    // if (page > 1) {
                        // Append new tickets to the existing list
                    setAllTickets((prev) => {
                        // Avoid duplication by filtering out tickets already in the list
                        const uniqueTickets = sorted.filter(
                            (newTicket) => !prev.some((existingTicket) => existingTicket.id === newTicket.id)
                        );
                        return [...prev, ...uniqueTickets];
                        });
                          
                    setTickets(sorted)
                    // Update pagination states
                    setCurrentPage(json.currentPage); // Set current page
                    setTotalPages(json.totalPages); // Total pages available
                    setTotalTickets(json.totalTickets); // Total tickets available
                    
                    // Check if more pages are available
                    setHasMore(json.currentPage < json.totalPages);
                } else {
                    // No tickets available
                    setTickets([]);
                    setHasMore(false);
                }
            } else {
                // Show error toast
                toast.error(json.error || json.message);
            }
        } catch (error) {
            console.error("Error fetching tickets:", error);
            toast.error("Something went wrong while fetching tickets.");
        } finally {
            // Reset loading states
            setFetching(false);
            setIsLoading(false);
            setLoad(false)
        }
    };

    const getRequests = async (page, filter = filters, deadLineFrom = fromDate, deadLineTo = toDate, search = searchValue, sort = sortBy, order = sortOrder) => {
        try {
            if(fetching && tickets.length > 1) return;
            setLoad(true)
            const response = await axios.get(`${process.env.REACT_APP_API_URL}api/request/getAllRequests/${page}`, {
                params: {
                    filters: filter,         // e.g., ['completed', 'high priority']
                    fromDate: deadLineFrom,       // e.g., '2025-01-01'
                    toDate: deadLineTo,           // e.g., '2025-01-31'
                    sortBy: sort,           // e.g., 'priority'
                    sortOrder: order,     // e.g., 'asc' or 'desc'
                    search: search,           // e.g., 'urgent'
                    limit: 15,             // Number of tickets per page (optional, defaults to 15)
                },
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${token}`,
                },
            });
            
            const json = response.data;
            if (json.success) { 
                if (json.requests) {
                    // Sort tickets by updated_at in ascending order
                    const sorted = json.requests
                    setRequests(sorted)

                    // Update pagination states
                    setRequestCurrentPage(json.currentPage); // Set current page
                    setRequestTotalPages(json.totalPages); // Total pages available
                    setRequestTotal(json.totalRequests); // Total tickets available
                    
                    // Check if more pages are available
                    setRequestHasMore(json.currentPage < json.totalPages);
                } else {
                    // No tickets available
                    setRequests([]);
                    setRequestHasMore(false);
                }
            } else {
                // Show error toast
                toast.error(json.error || json.message);
            }
        } catch (error) {
            console.error("Error fetching Requests:", error);
            toast.error("Something went wrong while fetching Requests.",error);
        } finally {
            // Reset loading states
            setFetching(false);
            setIsLoading(false);
            setLoad(false)
        }
    };
    
    const getAgencies = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + "api/agency/get", {
                headers: {
                    "Content-Type": "application/json",
                    'auth-token': `${token}`
                }
            });
            const json = response.data;
            if (json.success) {
                setAgencies(json.agencies);
            } else {
                console.log(json.error || json.message);
                toast.error(json.error || json.message || "Some Error occurred");
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getTags = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + "api/agency/getAllTags", {
                headers: {
                    "Content-Type": "application/json",
                    'auth-token': `${token}`
                }
            });
            const json = response.data;
            if (json.success) {
                setTags(json.tags);
            } else {
                console.log(json.error || json.message);
                toast.error(json.error || json.message || "Some Error occurred");
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getAgency = async (id) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + `api/agency/getAgency/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    'auth-token': `${token}`
                }
            });
            const json = response.data;
            if (json.success) {
                setAgency(json.agency)
            } else {
                console.log(json.error || json.message);
                toast.error(json.error || json.message || "Some Error occurred");
                return
            }
        } catch (error) {
            console.log(error);
            return
        }
    };

    
    const fetchGroupDetails = async () => {
        try {
          const response = await fetch(process.env.REACT_APP_API_URL + 'api/group/get', { // Replace '1' with actual group ID
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'auth-token': `${localStorage.getItem('token')}`,
            },
          });
    
          if (response.ok) {
            const data = await response.json();
            setGroupDetails(data.groups);
          } else {
            const error = await response.json();
            console.log(error)
          }
        } catch (error) {
          console.error('Error fetching group details:', error);
        }
      };

      const verifyUser = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}api/auth/verify-user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: localStorage.getItem('token') }),
            });
    
            const json = await response.json();    
            if (json.success) {
                setUser_verified(true);
                return { success: true }; // Return user info for further actions
            } else {
                setUser_verified(false);
                return { success: false };
            }
        } catch (error) {
            console.error("Error verifying user:", error);
            setUser_verified(false);
            return { success: false, error };
        }
    };
    
    const fetchNotifications = async () => {
        try {
    
          const response = await axios.get(process.env.REACT_APP_API_URL + 'api/ticket/notifications', {
            headers: {
              'auth-token': `${token}`
            }
          })
    
          const json = response.data;
    
          if (json.success) {
            setNotifications(json.data)
          } else {
            console.log(json.message)
          }
    
        } catch (error) {
          console.log(error)
        }
      }

    return (
        <UserContext.Provider value={{detailModal, setDetailModal, fetchNotifications, verifyUser, user_verified, user, fetchGroupDetails, setUser, getUser, token, getEmployees, StoreToken, getTickets,getRequests, getAgencies, getAgencyUsers, getAgency, getTags}}>
            {props.children}
        </UserContext.Provider>
    )
}

export default User
